import React, { useState } from 'react'
import { Formik } from 'formik'
import { NotifyDialog } from '~/components/notify'
import { Grid, SvgIcon, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { appStore, authStore } from '~/stores'
import { TextField } from '@opus/web.core.form.text-field'
import { composeT, email, phone, required } from '~/common/validator'
import { EmailField } from '@opus/web.core.form.email-field'
import { AutoCompleteField, PhoneField } from '~/components/fields'
import { ProfileSvg, RecruiterSvg, ReferSvg } from '~/components/icons'
import { careReferralStore } from '~/features/care-referral/care-referral.store'
import { observer } from '~/common/mobx.decorator'
import { careReferralTravelStore } from '~/features/care-referral-traveller/care-referral-traveller.store'
import { TooltipReferDialog } from '~/components/tooltip-refer-dialog'

const ReferrelDialogComponent = observer(({ title, buttonAction, isShowIcon = false, job, open, setOpen }) => {
	const { t } = useTranslation()
	const { onSubmit } = careReferralStore
	const { recruiterOptions } = careReferralTravelStore
	const [openTooltip, setOpenTooltip] = useState(false)

	return (
		<>
			<Formik
				initialValues={{}}
				onSubmit={async (variables, { setErrors, resetForm }) => {
					await onSubmit(variables, { setErrors, resetForm }, job, setOpen)
				}}
				enableReinitialize={true}
			>
				{({ handleSubmit, isSubmitting }) => (
					<NotifyDialog
						showButtonClose={true}
						onClose={() => setOpen(false)}
						okProps={{ loading: isSubmitting, disabled: isSubmitting }}
						title={title}
						open={open}
						onOk={handleSubmit}
						okText={buttonAction}
					>
						<form onSubmit={handleSubmit}>
							<Grid container={true} spacing={3}>
								{authStore.isAnonymous && (
									<>
										{isShowIcon && (
											<Grid
												style={{
													display: 'flex',
													alignItems: 'center',
													paddingTop: 5,
													paddingBottom: 5,
												}}
												item
												xs={12}
											>
												<SvgIcon style={{ fill: 'none' }} component={ProfileSvg} />
												<Typography
													css={[
														appStore.getTheme.typography.subtitle2,
														{
															color: appStore.getTheme.colors.content.veryDark,
															marginLeft: 8,
														},
													]}
												>
													Referrer Information
												</Typography>
											</Grid>
										)}

										<Grid item xs={6}>
											<TextField required={true} name="referrerFirstName" label={t('FIRST_NAME')} validate={composeT(t)(required)} />
										</Grid>
										<Grid item xs={6}>
											<TextField required={true} name="referrerLastName" label={t('LAST_NAME')} validate={composeT(t)(required)} />
										</Grid>
										<Grid item xs={12}>
											<EmailField required={true} name="referrerEmail" label={'Email Address'} validate={composeT(t)(required, email)} />
										</Grid>
										<Grid item xs={12}>
											<PhoneField name="referrerPhone" label={t('PHONE_NUMBER')} validate={composeT(t)(phone)} />
										</Grid>
									</>
								)}
								{isShowIcon && (
									<Grid
										style={{
											display: 'flex',
											alignItems: 'center',
											paddingTop: 5,
											paddingBottom: 5,
										}}
										item
										xs={12}
									>
										<SvgIcon style={{ fill: 'none' }} component={ReferSvg} />
										<Typography
											css={[
												appStore.getTheme.typography.subtitle2,
												{
													color: appStore.getTheme.colors.content.veryDark,
													marginLeft: 8,
												},
											]}
										>
											Referee Information
										</Typography>
									</Grid>
								)}

								<Grid item xs={6}>
									<TextField required={true} name="firstName" label={t('FIRST_NAME')} validate={composeT(t)(required)} />
								</Grid>
								<Grid item xs={6}>
									<TextField required={true} name="lastName" label={t('LAST_NAME')} validate={composeT(t)(required)} />
								</Grid>
								<Grid item xs={12}>
									<EmailField required={true} name="email" label={'Email Address'} validate={composeT(t)(required, email)} />
								</Grid>
								<Grid item xs={12}>
									<PhoneField name="phone" label={t('PHONE_NUMBER')} validate={composeT(t)(phone)} />
								</Grid>
								{recruiterOptions.length > 0 && (
									<>
										<Grid
											style={{
												marginTop: 5,
												display: 'flex',
												alignItems: 'center',
												paddingTop: 5,
												paddingBottom: 5,
											}}
											item
											xs={12}
										>
											<SvgIcon style={{ fill: 'none' }} component={RecruiterSvg} />
											<Typography
												css={[
													appStore.getTheme.typography.subtitle2,
													{
														color: appStore.getTheme.colors.content.veryDark,
														marginLeft: 8,
													},
												]}
											>
												Select Your Recruiter (If applicable)
											</Typography>
										</Grid>
										<Grid item xs={12}>
											<AutoCompleteField fullWidth={true} label={'Recruiter'} name={'recruiterId'} options={recruiterOptions} />
										</Grid>
									</>
								)}
							</Grid>
						</form>
					</NotifyDialog>
				)}
			</Formik>
			<TooltipReferDialog openTooltip={openTooltip} setOpenTooltip={setOpenTooltip} />
		</>
	)
})

export default ReferrelDialogComponent
